import React from 'react';
import { renderTournamentPlayersList } from '../helpers/renderTournamentPlayersList';
import { useTranslation } from 'react-i18next';

const drawTrack = ({ style, ...props }) => {
  const finalStyle = {
    ...style,
    right: 2,
    bottom: 2,
    borderRadius: 3,
  };
  return (<div style={finalStyle} {...props} className="tournaments__player-list__track-vertical" />);
}

const TournamentPlayerList = ({ playerList, showMorePlayersMobile, showPlayerPosition}) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      { renderTournamentPlayersList(playerList, t, showMorePlayersMobile, showPlayerPosition) }
    </React.Fragment>
  );
}

export default TournamentPlayerList;